<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app1"
};
</script>
